import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { CircularProgress, Grid2 as Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { getCatalogSampleTypes } from "../../repositories/CatalogSampleTypeRepository";
import { useCatalogSampleTypeContext } from "./CatalogSampleTypeContext";
import { TableSampleType } from "./components/TableSampleType";

type Props = {};
export const CatalogSampleTypePage = (props: Props) => {
	const { state, actions } = useCatalogSampleTypeContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getCatalogSampleTypesFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogSampleTypes();
		if (resp.ok) {
			actions.setSampleTypes(resp.data.tables[0].rows);
			setIsLoading(false);
		} else {
			setError(resp.message);
		}
	};

	useEffect(() => {
		getCatalogSampleTypesFromAPI();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	if (state.sampleTypes) {
		return (
			<>
				<HelmetDexteel title="Sample Types - Configurations" />
				<Grid container justifyContent="center" alignItems="center">
					<Grid size={{ xs: 12, md: 12 }} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TableSampleType
								isLoading={isLoading}
								getCatalogSampleTypesFromAPI={getCatalogSampleTypesFromAPI}
							/>
						</Paper>
					</Grid>
				</Grid>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
	return (
		<Grid
			size={{ xs: 12 }}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};
